import {
  Component,
  Input,
  ElementRef,
} from '@angular/core'

@Component({
  selector: 'item-group-foldout',
  templateUrl: './item-group-foldout.component.html',
  styleUrls: ['./item-group-foldout.component.less'],
})
export class ItemGroupFoldoutComponent {
  @Input() name: string
  $element: any

  constructor(
    private elementRef: ElementRef,
  ) {}

  ngAfterViewInit() {
    this.$element = $(this.elementRef.nativeElement).find('.ui.accordion')
    this.$element.accordion()
  }
}
